import { Injectable }             from '@angular/core';
import { CanActivate, CanActivateChild, Router }         from '@angular/router';

import { PermissionsService } from '../shared/services/permissions.service';

@Injectable()
export class CheckForSimplifiedSessionManagementChild implements CanActivateChild {
  constructor(private router: Router, private permissionsService: PermissionsService) {}

  canActivateChild(): boolean {
    if (this.permissionsService.simplifiedSessionManagement) {
      this.router.navigate(['/dashboard/new-programs']);
      return false;
    } else {
      return true;
    }
  }
}

@Injectable()
export class CheckForSimplifiedSessionManagement implements CanActivate {
  constructor(private router: Router, private permissionsService: PermissionsService) {}

  canActivate(): boolean {
    if (this.permissionsService.simplifiedSessionManagement) {
      this.router.navigate(['/dashboard/new-programs']);
      return false;
    } else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/guards.ts